import { PreSaleSku } from './entities/PreSaleSku'
import { TableHeaderConfigWithType } from '../../components/_EOS/Table'
import { Avatar, Tooltip, Typography } from '@mui/material'
import React from 'react'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'

export const generateTableHeadersPreSaleSku = () => {
  const tableHeaders: TableHeaderConfigWithType<PreSaleSku>[] = [
    {
      field: 'urlImage',
      title: 'Imagen',
      sortable: true,
      formater: (image: unknown) => setImage(image as string)
    },
    {
      field: 'sku',
      title: 'SKU',
      sortable: true
    },
    {
      field: 'name',
      title: 'Producto',
      sortable: false
    },
    {
      field: 'brandName',
      title: 'Marca',
      sortable: false
    },
    {
      field: 'qtyVirtualStock',
      title: 'Cantidad',
      sortable: false,
      formater: (qty, entity) => setQty(qty as number, entity as PreSaleSku)
    }
  ]

  return tableHeaders
}

const setQty = (qty: number, entity: PreSaleSku): React.ReactElement => {
  if (entity.isInfiniteQty)
    return (
      <Tooltip title={`Stock infinito`}>
        <AllInclusiveIcon fontSize='medium' />
      </Tooltip>
    )

  return <Typography>{qty}</Typography>
}

const setImage = (pImage?: string | null) => {
  const image =
    pImage && pImage.trim() !== ''
      ? pImage
      : 'https://via.placeholder.com/150/e5e5e5/808080?text=Sin%20Imagen'

  return (
    <Avatar
      style={{ height: '60px', width: '60px' }}
      variant='square'
      alt='SkuImage'
      src={image}
    />
  )
}
